import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ThumbsUp, ThumbsDown } from "lucide-react";
import { cn } from "@/lib/utils";

interface FeedbackButtonsProps {
  onPositive: () => void;
  onNegative: () => void;
  size?: "sm" | "default";
  className?: string;
}

export function FeedbackButtons({
  onPositive,
  onNegative,
  size = "sm",
  className,
}: FeedbackButtonsProps) {
  const [feedback, setFeedback] = useState<"positive" | "negative" | null>(null);

  const handlePositive = () => {
    setFeedback("positive");
    onPositive();
  };

  const handleNegative = () => {
    setFeedback("negative");
    onNegative();
  };

  const iconSize = size === "sm" ? "h-3 w-3" : "h-4 w-4";

  return (
    <div className={cn("flex items-center gap-1", className)}>
      <Button
        variant="ghost"
        size="icon"
        className={cn(
          "h-6 w-6",
          feedback === "positive" && "text-primary bg-primary/10"
        )}
        onClick={handlePositive}
        disabled={feedback !== null}
      >
        <ThumbsUp className={iconSize} />
        <span className="sr-only">Helpful</span>
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className={cn(
          "h-6 w-6",
          feedback === "negative" && "text-destructive bg-destructive/10"
        )}
        onClick={handleNegative}
        disabled={feedback !== null}
      >
        <ThumbsDown className={iconSize} />
        <span className="sr-only">Not helpful</span>
      </Button>
    </div>
  );
}
